import PdfPreview from "./pdf_preview.vue";
import Reason from "./reason_delete.vue";
import StudentList from "./student_list.vue";
import AcademicInfo from "./academic.vue";
import ItemDetail from "./item_detail.vue";

export {
    PdfPreview,
    Reason,
    StudentList,
    AcademicInfo,
    ItemDetail
}